import React from "react";
import { FloatLabel } from "primereact/floatlabel";
import { InputNumber, InputNumberChangeEvent } from "primereact/inputnumber";
import styles from "../index.module.css";

interface ParamProps {
  fieldName: string;
  label: string;
  currentObject: any;
  isDisable?: boolean;
  isInvalid?: boolean;
  style?: React.CSSProperties; 
  max?: number | null;
  min?: number;
  suffix?: string;
  getValue: number | undefined | null;
  setValue: (updatedObject: any) => void;
  allowDecimals?: boolean; 
}

const InputNumberComponent: React.FC<ParamProps> = (params: ParamProps) => {
  const handleChange = (e: InputNumberChangeEvent) => {
    const newValue = e.value ?? 0;
    const updatedObject = {
      ...params.currentObject,
      [params.fieldName]: newValue,
    };
    params.setValue(updatedObject);
  };

  return (
    <FloatLabel>
      <InputNumber
        className="w-full"
        min={params.min ?? undefined}
        max={params.max || undefined}
        placeholder={params.label}
        value={params?.getValue}
        disabled={params.isDisable || false}
        invalid={params.isInvalid || false}
        onChange={handleChange}
        suffix={params.suffix || undefined}
         mode="decimal"
        minFractionDigits={0}
        maxFractionDigits={params.allowDecimals ? 10 : 0}
        inputStyle={params.style}
      />
      <label className={styles.label} htmlFor={params.fieldName}>{params.label}</label>
    </FloatLabel>
  );
};

export default InputNumberComponent;